import englishMessages from 'ra-language-english'
import { TranslationMessages } from 'react-admin'

englishMessages.ra.boolean.null = 'Not specified'

const customEnglishMessages: TranslationMessages = {
  ...englishMessages,
  feed: {
    title: 'Portals & feed',
    intro:
      'The NautiX feed goes to boat24 / Boatvertizer daily, who pass it on to the portals. This page shows whether it runs, which boats go out, and when the portals fetch it.',
    url: 'Feed address',
    copy: 'Copy address',
    copied: 'Address copied',
    tiles: {
      feed: 'Feed',
      enabled: 'on',
      disabled: 'off',
      enabled_sub: 'regenerated after every change',
      disabled_sub: 'nothing is published',
      adverts: 'Adverts in the feed',
      adverts_sub: 'published %{when}',
      never: 'never published',
      held_back: 'Held back',
      held_back_sub: 'released, but incomplete',
      fetches: 'Fetches (30 days)',
      last_fetch: 'last %{when}',
      no_fetch: 'never fetched',
    },
    generate: 'Regenerate feed',
    generating: 'Generating the feed …',
    force: 'Publish anyway',
    force_confirm: 'Really publish? Every advert missing from the new feed ends on every portal.',
    cancel: 'Cancel',
    outcome: {
      published: 'Published: %{count} adverts.',
      rejected: 'Held back. %{reason}',
      failed: 'Failed. %{reason}',
    },
    bv: {
      title: 'Boatvertizer: views and inquiries',
      as_of: 'as of %{date}',
      hint: "Boatvertizer's figures for the period Boatvertizer evaluates, all portals together.",
      views: 'Detail views',
      views_short: 'Views',
      inquiries: 'Inquiries',
      online: 'Adverts online',
      online_sub: 'according to Boatvertizer',
      chart: 'Detail views per day, all adverts',
      listing: 'Advert',
      portals: 'Portals',
      ctr: 'Click rate',
      crm_boat: 'in the CMS: %{name}',
      not_matched: 'not matched to a boat in the CMS',
      empty: 'No figures from Boatvertizer yet.',
      gone: '%{smart_count} advert from an earlier fetch is no longer at Boatvertizer and is hidden. |||| %{smart_count} adverts from earlier fetches are no longer at Boatvertizer and are hidden.',
      account: {
        title: 'Boatvertizer login',
        intro:
          'With this login the CMS fetches the figures from Boatvertizer itself, daily. The password is stored encrypted on the server and never shown here again.',
        username: 'Boatvertizer username',
        password: 'Password',
        save: 'Save and fetch',
        saved: 'Login saved.',
        change: 'Change login',
        cancel: 'Cancel',
        stored: 'Stored for %{username}, on %{date}.',
        fetch: 'Fetch now',
        fetching: 'Fetching … (takes about half a minute)',
        never: 'Not fetched yet.',
        last_ok: 'Last fetched %{when}: %{message}',
        last_failed: 'Fetch %{when} failed: %{message}',
        daily: 'Fetched automatically every day.',
      },
    },
    reasons: {
      disabled: 'The feed is switched off.',
      settings: 'The settings are incomplete.',
      shrink: 'Shrink guard: too many adverts would drop out.',
      invalid: 'The feed does not match the NautiX schema.',
      other: 'Generating failed.',
    },
    boats: {
      title: 'Released boats',
      empty: 'No boat is released to the portals yet (edit a boat → "Portals").',
      boat: 'Boat',
      state: 'State',
      in_feed: 'in the feed',
      held: 'held back',
      missing: 'missing: %{fields}',
      unpublished:
        '%{smart_count} more boat is not released. |||| %{smart_count} more boats are not released.',
    },
    runs: {
      title: 'Recent runs',
      when: 'Time',
      result: 'Result',
      adverts: 'Adverts',
      message: 'Message',
      published: 'published',
      rejected: 'held back',
      failed: 'failed',
      empty: 'No run yet.',
      summary_adverts: '%{smart_count} advert |||| %{smart_count} adverts',
      summary_skipped: '%{smart_count} held back',
      summary_warnings: '%{smart_count} note |||| %{smart_count} notes',
    },
    fetches: {
      title: 'Fetches',
      hint: 'Every request for the feed address. boat24 fetches once a day once the address is registered there.',
      when: 'Time',
      client: 'Client',
      result: 'Result',
      size: 'Size',
      empty: 'No fetches yet.',
      status_200: 'new version',
      status_304: 'unchanged',
      status_404: 'no feed',
    },
    settings: {
      title: 'Settings',
      edit: 'Edit',
      save: 'Save',
      saved: 'Settings saved.',
      incomplete: 'The feed still needs: %{fields}.',
      feed_enabled: 'Feed on',
      feed_enabled_hint: 'Off: nothing is published; the portals keep the last version.',
      account_name: 'Dealer name',
      office_name: 'Office',
      office_address: 'Street',
      office_postcode: 'Postcode',
      office_town: 'Town',
      office_country: 'Country (ISO, e.g. DE)',
      office_email: 'Email',
      office_phone: 'Phone',
      strip_contact_details: 'Remove contact details from descriptions',
      strip_contact_details_hint:
        'Many portals forbid phone numbers and addresses in the description.',
      shrink_guard_percent: 'Shrink guard (%)',
      shrink_guard_percent_hint:
        'If more adverts drop out, nothing is published: a missing advert ends on every portal.',
    },
  },
  auth: {
    mfa: {
      title: 'Two-factor sign-in',
      code: 'Code from the authenticator app',
      hint: '6 digits, new every 30 seconds',
      confirm: 'Confirm',
      back: 'Back to sign-in',
      invalid: 'That code is not right — please enter the current code from the app.',
    },
  },
  account: {
    title: 'My account',
    calendar: {
      title: 'Calendar on phone and computer',
      intro:
        'The CMS can be added as a calendar account — on iPhone, iPad and Mac directly, on Android with the DAVx⁵ app, in Thunderbird, and in Outlook with an add-on. There are two calendars: “Yachthandel24” with one’s own appointments (where one is listed as responsible) and “Yachthandel24 – Team” with the colleagues’, read only. Signing in uses a calendar password of its own, not the CMS password.',
      setup: 'Set up the calendar',
      issued:
        'Enter these in the calendar on the device. The password is shown only now; if it gets lost, simply make a new one.',
      server: 'Server',
      url: 'Address (when asked for a URL)',
      username: 'User name',
      password: 'Password',
      copy: 'Copy',
      done: 'Done, it is entered',
      used: 'Last synced: %{when} (%{client})',
      unused: 'Set up, but no device has synced yet.',
      writable: 'Take changes from the device',
      writable_on:
        'Both ways: own appointments can be created, moved and deleted on the device; the CMS takes it over.',
      writable_off:
        'Read only: the device shows the appointments; changes there do not reach the CMS.',
      show_team: 'Show the colleagues’ appointments',
      show_team_hint: 'As a second calendar “Yachthandel24 – Team”, read only.',
      saved: 'Saved. The device picks it up at its next sync.',
      new_password: 'New password',
      new_password_title: 'Make a new calendar password?',
      new_password_hint:
        'The current password stops working at once. Every device then needs the new one.',
      remove: 'Turn off',
      remove_title: 'Turn off calendar sync?',
      remove_hint:
        'No device can sign in afterwards. The account on the device can be deleted; the appointments in the CMS stay.',
      removed: 'Calendar sync turned off.',
      howto: 'How to set it up on each device',
      devices: {
        iphone: {
          name: 'iPhone and iPad',
          steps:
            'Settings → Apps → Calendar → Calendar Accounts → Add Account → Other → Add CalDAV Account. Server: %{server}, plus user name and password from above.',
        },
        mac: {
          name: 'Mac',
          steps:
            'Calendar → Settings → Accounts → + → Other CalDAV Account. Account type “Manual”, user name and password from above, server address: %{url}',
        },
        android: {
          name: 'Android',
          steps:
            'Install the DAVx⁵ app (Play Store or F-Droid) → add account → “Login with URL and user name”. Base URL: %{url}, plus user name and password. The calendars then show in the calendar app.',
        },
        thunderbird: {
          name: 'Thunderbird',
          steps:
            'Calendar → New Calendar → On the Network. User name from above, location: %{url}. Thunderbird then asks for the password.',
        },
        outlook: {
          name: 'Outlook (Windows)',
          steps:
            'Outlook cannot do CalDAV by itself. With the free add-on “CalDav Synchronizer” it works: new profile, address %{url}, user name and password from above.',
        },
      },
    },
    mfa: {
      title: 'Two-factor sign-in',
      intro:
        'Besides the password, signing in asks for a code from an authenticator app on the phone, e.g. Google Authenticator, Microsoft Authenticator or Apple Passwords. A guessed password alone is then not enough.',
      on: 'On: every sign-in asks for the code.',
      off: 'Off.',
      setup: 'Set up',
      scan: 'Scan the QR code with the authenticator app — or enter the key by hand. Then enter the code it shows here.',
      qr: 'QR code for the authenticator app',
      code: 'Code from the app',
      activate: 'Turn on',
      activated: 'Two-factor sign-in turned on.',
      disable: 'Turn off',
      disable_title: 'Turn off two-factor sign-in?',
      disable_hint: 'Enter the current code from the app to confirm.',
      disabled: 'Two-factor sign-in turned off.',
      locked: 'Mandatory for administrators — it cannot be turned off.',
      invalid: 'That code is not right — please enter the current code.',
      required_title: 'Please set up two-factor sign-in',
      required:
        'Two-factor sign-in is mandatory for administrators. Once it is set up, you can carry on.',
      team: 'In the team',
      status_on: 'set up',
      status_off: 'not set up',
      reset: 'Reset',
      reset_title: 'Reset two-factor sign-in for %{name}?',
      reset_hint:
        'For example after a lost phone: %{name} then signs in with the password only and sets up two-factor sign-in again.',
      reset_done: 'Two-factor sign-in reset for %{name}.',
      require: 'Make it mandatory for all administrators',
      require_hint: 'Whoever has not set it up yet is asked to at their next sign-in.',
      require_own_first: 'Set it up for your own account first.',
    },
  },
  error_page: {
    details: 'Technical details',
  },
  catalog: {
    title: 'Used yacht catalogue',
    intro:
      'Upload a new issue here as it comes from the layout. The CMS makes the version for the website (a much smaller PDF) and the cover image; the website shows the new issue within 15 minutes by itself.',
    current: 'On the website',
    none: 'No issue uploaded yet — until then the website shows the catalogue it has.',
    issue: 'Issue %{issue}',
    cover: 'Cover of issue %{issue}',
    since: 'since %{date}',
    pages: '%{pages} pages',
    web_pdf: 'Website PDF',
    original: 'Original',
    new: 'New issue',
    drop: 'Drop a PDF here or click',
    not_pdf: 'Please choose a PDF file.',
    issue_number: 'Issue',
    replaces: 'Issue %{issue} exists already — it will be replaced.',
    publish: 'Upload and publish',
    uploading: 'Uploading … (%{size}, a minute or two depending on the connection)',
    processing: 'Making the website version … (about a minute)',
    published:
      'Issue %{issue} is published: %{original} → %{web}, %{pages} pages. The website shows it within 15 minutes.',
    all: 'All issues',
    published_on: 'Published',
    pages_column: 'Pages',
  },
  social: {
    title: 'Social media',
    intro:
      'A ready post for Instagram and the like: up to ten images in the right format, the first with name, key facts and price, plus the text. Download it, share it from a phone, or publish it straight to Instagram.',
    boat: 'Boat',
    occasion: 'Occasion',
    occasions: {
      new: 'New in stock',
      price: 'Price reduced',
      sold: 'Sold',
      none: 'no occasion',
    },
    format: 'Format',
    formats: {
      post: 'Post 4:5',
      square: 'Square',
      story: 'Story 9:16',
    },
    choose_boat: 'Choose a boat first.',
    no_photos: 'This boat has no photos yet. Add some under "Prepare photos".',
    photos: 'Images (%{count} of at most %{max})',
    photos_hint: 'Click to select or deselect; the order of selection is the order in the post.',
    logo_on_all: 'Logo on every image',
    logo_hint: 'Photos from “Prepare photos” have their logo already and get no second one.',
    preview: 'Preview',
    download: 'Download as ZIP',
    share: 'Share',
    downloaded:
      'Downloaded %{smart_count} image with text. |||| Downloaded %{smart_count} images with text.',
    caption: 'Text',
    caption_hint: '%{count} of 2,200 characters',
    copy: 'Copy text',
    copied: 'Text copied.',
    copy_failed: 'Could not copy — please select and copy the text.',
    how_to: 'In Instagram: new post → pick the images in this order → paste the text.',
    publish: 'Publish on Instagram',
    connect_first: 'Connect Instagram',
    confirm_title: 'Publish on Instagram?',
    confirm_feed:
      '%{smart_count} image as a post on @%{username}, with the caption beside it. |||| %{smart_count} images as one post on @%{username}, with the caption beside it.',
    confirm_story:
      '%{smart_count} image as a story on @%{username}. Stories have no caption. |||| %{smart_count} images as stories on @%{username}, one after another. Stories have no caption.',
    confirm_go: 'Publish',
    cancel: 'Cancel',
    uploading: 'Uploading the images …',
    publishing: 'Instagram is taking the images … (about a minute)',
    published: 'Published on Instagram: %{message}.',
    view_post: 'View',
    instagram: {
      title: 'Instagram account',
      intro:
        'With a connected account the CMS publishes posts and stories directly. The login happens at Instagram itself; the CMS never sees your Instagram password.',
      setup: 'One-time setup:',
      step_account:
        'Switch the Instagram account to a professional account (business or creator) — in the Instagram app under Settings → Account type.',
      step_app:
        'On developers.facebook.com create an app of type “Business” and add the “Instagram” product (API setup with Instagram login).',
      step_redirect: 'There, in the Instagram business login settings, add this redirect URL:',
      step_tester:
        'Under App roles add the Instagram account as an Instagram tester and accept the invitation in Instagram.',
      step_keys: 'Enter the Instagram app ID and Instagram app secret from there here.',
      app_id: 'Instagram app ID',
      app_secret: 'Instagram app secret',
      save: 'Save',
      saved: 'App saved. Now connect with Instagram.',
      app_stored: 'App %{app_id} stored.',
      connect: 'Connect with Instagram',
      change_app: 'Change app',
      connected:
        'Connected to @%{username} since %{since}. Access is valid until %{until} and is renewed automatically.',
      disconnect: 'Disconnect',
      disconnected: 'Instagram account disconnected.',
      refresh_failed: 'Renewing access failed: %{message}',
      expired: 'Access to @%{username} has expired — please connect again.',
      recent: 'Recently published',
      kinds: { feed: 'Post', story: 'Story' },
      connecting: 'Connecting with Instagram …',
      connected_as: 'Connected to @%{username}.',
      denied: 'Instagram did not allow the connection: %{reason}',
      bad_state:
        'This answer from Instagram does not belong to a login started here. Please “Connect with Instagram” again.',
      back: 'Back to Social media',
    },
  },
  photos: {
    title: 'Prepare photos',
    drop: 'Drop photos here or click',
    drop_hint:
      'JPEG, PNG or WebP, many at once. Each photo is corrected automatically (tone, colour cast, dark interiors).',
    preparing: 'Preparing photos',
    processing: 'Finishing photos',
    uploading: 'Saving photos',
    unreadable:
      'The browser cannot read this format (e.g. HEIC from an iPhone) — please export as JPEG.',
    sort_hint: '%{smart_count} photo – drag to sort |||| %{smart_count} photos – drag to sort',
    show_original: 'Show original',
    move_left: 'Move forward',
    move_right: 'Move back',
    rotate: 'Rotate',
    correct: 'Automatic correction',
    remove: 'Remove',
    settings: 'Settings',
    size: 'Size (longest edge)',
    size_px: '%{size} px',
    size_original: 'Original size',
    enhance: 'Automatic correction',
    sharpen: 'Sharpen',
    sharpen_off: 'off',
    sharpen_light: 'light',
    sharpen_strong: 'strong',
    watermark: 'Add logo',
    logo_choose: 'Other logo …',
    logo_default: 'Default logo',
    position: 'Position',
    positions: {
      'top-right': 'top right',
      'top-left': 'top left',
      'bottom-right': 'bottom right',
      'bottom-left': 'bottom left',
      center: 'centre',
    },
    logo_size: 'Logo size',
    opacity: 'Opacity',
    halo: 'Light glow behind the logo (for dark photos)',
    reset: 'Reset settings',
    finish: 'Finish',
    file_prefix: 'File name',
    file_example: 'e.g. %{name}',
    download: 'Download as ZIP (%{smart_count})',
    downloaded: '%{smart_count} photo downloaded. |||| %{smart_count} photos downloaded.',
    boat: 'Boat',
    save_to_boat: 'Save to boat (%{smart_count})',
    save_hint:
      'The photos are added after the boat’s existing photos, in this order — which is also how they reach Boatvertizer and the website.',
    saved: '%{smart_count} photo saved to %{boat}. |||| %{smart_count} photos saved to %{boat}.',
    open_boat: 'Open boat',
    unsaved:
      '%{smart_count} photo is not saved yet. “Save to boat” adds it to the boat. |||| %{smart_count} photos are not saved yet. “Save to boat” adds them to the boat.',
    unsaved_leave:
      'The prepared photos are not saved to a boat yet and will be lost if you leave this page. Leave anyway?',
  },
  dashboard: {
    title: 'Dashboard',
    morning: 'Good morning',
    day: 'Hello',
    evening: 'Good evening',
    new_boat: 'New boat',
    new_customer: 'New customer',
    new_appointment: 'New appointment',
    photos: 'Prepare photos',
    inventory: 'Inventory',
    no_status: 'no status',
    upcoming: 'Next appointments',
    upcoming_none: 'No appointments in the next 14 days.',
    all_appointments: 'All appointments',
    today: 'today',
    tomorrow: 'tomorrow',
    all_day: 'all day',
    in_charge: 'In charge: %{names}',
    todo: 'To do',
    todo_hint: 'Boats being worked on or offered that still lack something.',
    todo_none: 'Nothing open: every boat being worked on or offered is complete.',
    todos: {
      no_photos: 'No photos (needed for the portals and Instagram)',
      no_price: 'No asking price',
      no_owner: 'No owner',
      below_limit: 'Offer price below the lower price limit',
    },
    more: 'and %{count} more',
    portals: 'Portals',
    portals_period: 'Boatvertizer, all portals together: %{from} to %{to}',
    inquiries: 'Inquiries',
    views: 'Views',
    top: 'Most asked about',
    top_line: '%{inquiries} inquiries · %{views} views',
    portals_none: 'No figures from Boatvertizer yet.',
    portals_fetched: 'Figures fetched on %{when}',
    portals_failed: 'The last fetch from Boatvertizer failed (see “Portals & feed”).',
    to_feed: 'Portals & feed',
    recent: 'Recently edited',
    recent_none: 'Nothing edited yet.',
  },
  filters: {
    active: 'Active filters',
    no_results: 'No matches.',
    no_results_search: 'No matches for “%{search}”.',
    filtered_by: 'Filtered by %{filters}.',
    clear: 'Clear filters',
  },
  pos: {
    search: 'Search',
    configuration: 'Configuration',
    language: 'Language',
    theme: {
      name: 'Theme',
      light: 'Light',
      dark: 'Dark',
      test: 'Test',
    },
    i18n: {
      show: 'Show Translations',
      hide: 'Hide Translations',
    },
    notes: {
      show: 'Notizen anzeigen',
      hide: 'Notizen ausblenden',
    },
  },
  resources: {
    marketing: {
      menu: 'Marketing',
    },
    phones: {
      title: 'Phones',
    },
    emails: {
      title: 'Emails',
    },
    customer_customer: {
      title: 'Customer to customer relations',
    },
    administration: {
      menu: 'Adminstration',
    },
    users: {
      title: 'Users',
      create: 'Add new User',
      fields: {
        username: 'Username',
        password: 'Password',
        id: 'User-ID',
        role: 'Role',
        email: 'Email',
        active: 'Active',
        disabled: 'Locked',
        last_seen: 'Last seen',
        new_password: 'New password',
        new_password_hint: 'Leave empty to keep it. Signs the user out everywhere.',
      },
    },
    suppliers: {
      menu: 'Supplier database',
      name: 'Supplier |||| Supplier',
      title: 'Supplier',
      empty: 'There are no supplier yet.',
      create: 'Add new supplier',
      base: 'General information',
      fields: {
        id: 'Supplier-ID',
        name: 'Company Name',
        services: 'Services',
        website: 'Website',
        email: 'Email',
        contact: {
          name: 'Contact Name',
          phone: 'Contact Phone',
          email: 'Contact Email',
        },
      },
    },
    customers: {
      menu: 'Customer database',
      name: 'Customer |||| Customers',
      title: 'Customer',
      empty: 'There are no customers yet.',
      create: 'Add new customer',
      base: 'General information',
      fields: {
        id: 'Customer-ID',
        title: 'Title',
        firstname: 'Firstname',
        lastname: 'Lastname',
        salutation: 'Salutation',
        role: 'Role',
        company: 'Company',
        identity_card_number: 'Identity card number',
        nationality: 'Nationality',
        birthday: 'Birthday',
        street: 'Street',
        postal_code: 'Postal code',
        city: 'City',
        country: 'Country',
        phones: 'Phone numbers',
        emails: 'E-mails',
        birth_name: 'Birth name',
        informal_salutation: 'informal',
        relationships: 'Relationships',
      },
      array_fields: {
        phone: 'Number',
        email: 'Email',
        type: 'Type',
      },
      types: {
        relation_to: 'Relations to',
        relation_from: 'Relations from',
        seller: 'Seller',
        suitor: 'Suitor',
        buyer: 'Buyer',
        brokered: 'Brokered',
        boats: 'Boats',
        boat_name: 'Boat Name',
      },
    },
    boats: {
      menu: 'Boot database',
      name: 'Boat |||| Boats',
      title: 'Boats',
      empty: 'There are no boats yet.',
      create: 'Add new boat',
      base: 'General information',
      attributes: 'Equipment',
      empty_attributes: 'No equipment added, yet',
      guided_input: 'Guided Input',
      types: {
        customers: 'Related Customers',
        customer_name: 'Customer Name',
      },
      fields: {
        id: 'Boat-ID',
        manufacturer: 'Manufacturer',
        model: 'Model',
        name: 'Name',
        build_year: 'Build year',
        first_launch: 'first launch',
        status: 'Status',
        asking_price: 'Asking price',
        offer_price: 'Offer price',
        offer_price_hint:
          'When set, this price is shown instead of the asking price on the social-media images and in the text.',
        lower_price_limit: 'Lower price limit',
        summer_storage: 'Summer storage',
        winter_storage: 'Winter storage',
        panorama_url: '360° tour (link)',
        panorama_url_hint:
          'Link to the 360° view (e.g. Kuula, Matterport). Goes to Boatvertizer with the feed and shows on the website as the 360° tour.',
        panorama_url_invalid: 'Please enter a complete https:// link.',
        boat_type: 'Boat type',
        motorboat_type: 'Motorboat',
        motorboat_planing_type: 'Type',
        sailboat_type: 'Sailboat',
        sailboat_rigging_type: 'Rigging',
        goods_type: 'Goods type',
        condition: 'Condition',
        previous_owners: 'Previous owners',
        build_number: 'Build number',
        ce_labeling: 'CE Labeling',
        hull_material: 'Hull material',
        hull_color: 'Hull color',
        keel_type: 'Keel type',
        lake_constance_approval: 'Lake constance approval',
        length_total: 'Total length (m)',
        length_waterline: 'Waterline length (m)',
        width: 'Width (m)',
        draft_max: 'Draft max. (m)',
        draft_min: 'Draft min. (m)',
        displacement: 'Displacement (kg)',
        ballast: 'Ballast (kg)',
        customer_id: 'Owner',
        relationships: 'Relationships',
        publish_nautix: 'Publish on the portals',
        publish_nautix_hint:
          'Through the NautiX feed to boat24 / Boatvertizer, and from there to the portals.',
        subtitle: 'Subtitle',
        subtitle_hint: 'One line, at most 60 characters.',
        translated_marketing_description: 'Description for the portals',
        location_town: 'Berth',
        location_country: 'Country',
        location_state: 'Region (optional)',
        location_state_hint: 'ISO code, e.g. DE-SH. Only some countries need it.',
        vat_status: 'VAT',
        vat_paid_area: 'VAT paid in',
        vat_paid_area_hint: 'Country code or EU',
        sale_status: 'Sale status on the portals',
        sale_status_none: 'for sale',
        external_reference: 'Reference number',
        external_reference_hint: 'Shown in the listing.',
      },
      relationships: {
        type: 'Type',
      },
      sections: {
        price: 'Price',
        storage: 'Storage',
        boat_type: 'Boat Type',
        condition: 'Condition',
        materials: 'Materials',
        certificates: 'Certificates',
        dimensions: 'Dimensions',
        media: 'Media',
        portals: 'Portals',
      },
      panorama: {
        title: '360°',
        empty: 'No 360° tour for this boat. Add the link under Edit → Media.',
        open: 'Open in a new window',
      },
      nautix: {
        ready: 'Ready for the portals.',
        missing: 'Still missing for the portals: %{fields}.',
        not_published: 'Not released: the boat appears on no portal.',
        required: {
          boat_type: 'boat type',
          model: 'model',
          price: 'asking price',
          location_country: 'country',
        },
      },
      choices: {
        vat_status: {
          paid: 'paid',
          'not-paid': 'not paid',
          unknown: 'unknown',
        },
        sale_status: {
          'under-offer': 'under offer',
          sold: 'sold',
        },
        status: {
          processing: 'In process',
          mediation: 'In mediation',
          handover: 'Sold in handover',
          settlement: 'Sold in settlement',
          completed: 'Sale completed',
          cancelled: 'Contract cancelled',
        },
        type: {
          sailboat: 'Sailing boat',
          motorboat: 'Motor boat',
        },
        motorboat_type: {
          cabin_cruiser: 'Cabin cruiser',
          fishing_boat: 'Fishing boat',
          catamaran: 'Catamaran',
          hovercraft: 'Hovercraft',
          houseboat: 'House boat',
        },
        motorboat_plan: {
          glider: 'Glider',
          'semi-glider': 'Half glider',
          displacer: 'Displacer',
        },
        sailboat_type: {
          center_cockpit: 'Center Cockpit',
          daysailer: 'Daysailer',
          decksalon: 'Deck saloon',
          dinghy: 'Dinghy',
          catamaran: 'Catamaran',
          trimaran: 'Trimaran',
          classic: 'Classic',
          motor_sailer: 'Motor sailer',
          flatboat: 'Flatboat',
        },

        sailboat_rigging: {
          kat: 'Kat',
          sloop: 'Sloop',
          schooner: 'Schooner',
          ketch: 'Ketch',
          yawl: 'Yawl',
          gaff: 'Gaff',
          cutter: 'Cutter',
        },

        usedboat: {
          used: 'Used boat',
          new: 'New boat',
          display: 'Display model',
        },

        boat_condition: {
          tinkerware: 'Tinkerware',
          casco: 'Casco',
          used: 'Used',
          good: 'Good',
          very_good: 'Very good',
          like_new: 'Like new',
          new: 'new',
        },
        boat_labels: {
          a: 'A - Deep sea',
          b: 'B - Outside coastal waters',
          c: 'C - Coastal waters',
          d: 'D - Protected waters',
        },
      },
    },
    sections: {
      title: 'Sections',
      name: 'Section |||| Sections',
      add: 'Add Section',
      fields: {
        slug: 'Definite name',
        name: 'Name',
        position: 'Position',
        category_count: '# Categories',
      },
    },
    categories: {
      title: 'Equipment',
      name: 'Category |||| Categories',
      add: 'Add Equipment',
      empty: 'There is no equipment yet.',
      create: 'Add new equipment',
      notes: 'Notes',
      notes_icon: 'Input state',
      fields: {
        id: 'Category-ID',
        name: 'Name',
        section: 'Section',
        description: 'Description',
        attributes: 'Available attributes',
        attribute_count: '# Attributes',
      },
    },
    attributes: {
      title: 'Equipment items',
      save_first: '» newly added option must be saved first «',
      hint_switching_input_type:
        'Hint: The attribute "%{attribute}" changed has existing data, changing input type may cause issues.',
      fields: {
        id: 'Attribute-ID',
        name: 'Name',
        description: 'Description',
        default_value: 'Default value',
        suffix: 'Suffix',
        unit: 'Unit',
        input_type: 'Input type',
        show_by_default: 'Show by default',
        hidden: 'hidden',
        choices: 'Choices',
        selection: 'Shared Selection',
      },
      types: {
        text: 'Text',
        autocomplete: 'Autocomplete',
        numeric: 'Number',
        boolean: 'Yes / No',
        dropdown: 'Dropdown',
        shared_dropdown: 'Shared Selection',
      },
    },
    selections: {
      title: 'Selections',
      add: 'add selection',
      empty: 'There are no selections yet.',
      create: 'Add new selection',
      fields: {
        id: 'Selection-ID',
        name: 'Name (internal)',
        section: 'Section',
        context: 'Context',
        predefined: 'Predefined',
        choices: 'Choices',
        choice_count: '# Choices',
      },
      contexts: {
        attributes: {
          choices: 'Equipment-Attributes',
        },
      },
    },
    choices: {
      create: 'Add choice',
      create_item: 'Add "%{item}"',
      fields: {
        key: 'Definite name',
        name: 'Name',
      },
    },
    comments: {
      name: 'Comment |||| Comments',
      empty: 'No comments, yet.',
      title: 'Comments',
      create: 'Comment',
      update: 'Change',
      remove: 'Remove',
      loading: 'Loading comments...',
      fields: {
        created_at: 'Created',
        updated_at: 'Updated',
        comment: 'Comment',
        type: 'Type',
        linked_type: 'Link to',
      },
      linked_types: {
        boats: 'Boat',
        customers: 'Customer',
      },
    },
    attachments: {
      name: 'Attachment |||| Attachments',
      empty: 'No attachments, yet.',
      title: 'Attachments',
      create: 'Create attachment',
      upload: 'Upload',
      uploaded: 'Attachment upload successful.',
      deleted: 'Attachment was deleted.',
      loading: 'Loading attachments...',
      fields: {
        type: 'Type',
        caption: 'Caption',
      },
    },
    appointments: {
      name: 'Appointment |||| Appointments',
      menu: 'Appointment management',
      title: 'Appointments',
      create: 'Add new appointment',
      empty: 'There are no appointments yet.',
      calendar_view: 'Calendar View',
      list_view: 'List View',
      new: 'new',
      fields: {
        title: 'Title',
        start: 'Start',
        end: 'End',
        type: 'Type',
        appointment_customer: 'Customers',
        appointment_boat: 'Boats',
        appointment_user: 'Responsible',
        appointment_user_hint:
          'Shows in these people’s own calendar (calendar sync under “My account”).',
        allDay: 'all day',
        location: 'Location',
        notes: 'Notes',
      },
      types: {
        none: 'None (other)',
        viewing: 'Viewing',
        handover: 'Handover',
        pickup: 'Pickup',
      },
    },
    documents: {
      name: 'Document |||| Documents',
      menu: 'Document management',
      title: 'Documents',
      create: 'Add new document',
      empty: 'There are no documents yet.',
      new: 'new',
      pdf_preview: 'PDF preview',
      fields: {
        title: 'Title',
        type: 'Type',
        document_customer: 'Customer(s)',
        document_boat: 'Boat(s)',
        notes: 'Notes',
      },
      types: {
        none: 'None (other)',
        brokerage_agreement: 'Brokerage Agreement',
      },
    },
    relations: {
      add: 'Add relationship',
      types: {
        seller: 'Seller',
        suitor: 'Suitor',
        buyer: 'Buyer',
        brokered: 'Brokered',
      },
    },
    history: {
      title: 'History',
      fields: {
        relation: 'Relation',
        operation: 'Action',
        time: 'Time',
      },
      operations: {
        INSERT: 'Insert',
        DELETE: 'Delete',
        UPDATE: 'Update',
      },
    },
    history_transactions: {
      name: 'History',
      title: 'History',
    },
  },
  general: {},
  validation: {
    phone: 'Digits, spaces and + ( ) - / . only',
    startEnd: 'Must be after start',
  },
  history: {
    modified_by: 'Modified by',
    last_modified: 'Last modifed',
  },
}

export default customEnglishMessages
